import { colorTokens, gradientTokens } from '../design-system/tokens';

export const borderStyle = {
  border: '1px solid',
  borderColor: colorTokens.whiteAlpha06,
  borderRadius: 2
};

export const sectionPanelStyle = {
  ...borderStyle,
  background: gradientTokens.surfacePanelDark
};

export const sectionHeaderPanelStyle = {
  ...borderStyle
  // backgroundColor: colorTokens.whiteAlpha02
};
